<template>
    <div class="public-client-anex-step" data-cy="public-client-anex-step">
        <div class="anex-hero">
            <div class="anex-hero__content">
                <span class="anex-hero__eyebrow">Documentos do cliente</span>
                <h4 class="anex-hero__title">Envie os anexos necessários para concluir o cadastro</h4>
                <p class="anex-hero__text">
                    Os documentos obrigatórios aparecem destacados. Voce tambem pode adicionar anexos opcionais quando
                    fizer sentido.
                </p>
            </div>

            <div class="anex-hero__status">
                <span class="anex-hero__status-icon">
                    <i class="icon-attach_file"></i>
                </span>
                <small>Progresso</small>
                <strong>{{ uploadedRequiredCount }} de {{ typesAnnex.required.length }} obrigatórios</strong>
            </div>
        </div>

        <div class="anex-summary-grid">
            <div class="anex-summary-card anex-summary-card--required">
                <span><i class="icon-error_outline"></i></span>
                <small>obrigatórios</small>
                <strong>{{ typesAnnex.required?.length }} tipos</strong>
            </div>

            <div class="anex-summary-card">
                <span><i class="icon-playlist_add_check"></i></span>
                <small>Enviados</small>
                <strong>{{ anexes.length }} arquivos</strong>
            </div>

            <div class="anex-summary-card">
                <span><i class="icon-archive"></i></span>
                <small>Formatos aceitos</small>
                <strong>PDF, PNG, JPG</strong>
            </div>
        </div>

        <div class="anex-upload-grid">
            <div class="anex-types-card">
                <div class="anex-types-card__header">
                    <div>
                        <span class="anex-types-card__eyebrow">Tipos de anexo</span>
                        <h5>Escolha um documento para enviar</h5>
                    </div>
                    <span class="anex-types-card__badge">Max. 9MB</span>
                </div>

                <div class="anex-types-section" v-if="typesAnnex.required?.length">
                    <div class="anex-types-section__title">
                        <strong>obrigatórios</strong>
                        <small>Precisam ser enviados para continuar.</small>
                    </div>

                    <button
                            v-for="type in typesAnnex.required"
                            :key="type.id"
                            type="button"
                            class="anex-type-option"
                            :class="{
                            'anex-type-option--active': selectedAttachmentType === type.id,
                            'anex-type-option--done': type.uploaded,
                        }"
                            @click="selectedAttachmentType = type.id; selectedAttachmentTypeName = type.text"
                    >
                        <span class="anex-type-option__icon"><i class="icon-upload"></i></span>
                        <span class="anex-type-option__content">
                            <strong>{{ type.text }}</strong>
                            <small>{{ type.description }}</small>
                            <div style="color:red;" v-if="invalid[type.id]">{{invalid[type.id]}}</div>
                        </span>
                        <span class="anex-type-option__badge">
                            {{ type.uploaded ? 'Enviado' : 'Obrigatório' }}
                        </span>
                    </button>
                </div>

                <div class="anex-types-section anex-types-section--optional" v-if="typesAnnex.not_required?.length">
                    <div class="anex-types-section__title">
                        <strong>Opcionais</strong>
                        <small>Adicione se houver necessidade.</small>
                    </div>

                    <button
                            v-for="type in typesAnnex.not_required"
                            :key="type.id"
                            type="button"
                            class="anex-type-option"
                            :class="{'anex-type-option--active': selectedAttachmentType === type.id}"
                            @click="selectedAttachmentType = type.id; selectedAttachmentTypeName = type.text"
                    >
                        <span class="anex-type-option__icon"><i class="icon-upload"></i></span>
                        <span class="anex-type-option__content">
                            <strong>{{ type.text }}</strong>
                            <small>{{ type?.description }}</small>
                        </span>
                        <span class="anex-type-option__badge anex-type-option__badge--optional">Opcional</span>
                    </button>
                </div>
            </div>

            <div class="anex-upload-card" :class="{'anex-upload-card--disabled': !selectedAttachment}">
                <div class="anex-upload-card__header">
                    <div>
                        <span class="anex-upload-card__eyebrow">Upload</span>
                        <h5>{{ selectedAttachment ? selectedAttachment.text : 'Selecione um tipo de anexo' }}</h5>
                    </div>
                    <span
                            class="anex-upload-card__badge"
                            :class="{'anex-upload-card__badge--required': selectedAttachmentIsRequired}"
                    >
                        {{
                            selectedAttachment ? (selectedAttachmentIsRequired ? 'Obrigatório' : 'Opcional') : 'Aguardando selecao'
                        }}
                    </span>
                </div>

                <div v-if="!selectedAttachment" class="anex-upload-card__empty">
                    <span><i class="icon-touch_app"></i></span>
                    <strong>Escolha primeiro um tipo de anexo</strong>
                    <small>
                        Selecione um item na lista ao lado para liberar o envio do arquivo correspondente.
                    </small>
                </div>

                <label v-else class="anex-dropzone" for="public_client_anex_file">
                    <input id="public_client_anex_file" type="file" class="d-none" data-cy="public-client-anex-file"
                           @change="addFile($event)"
                    >
                    <span class="anex-dropzone__icon"><i class="icon-file_upload"></i></span>
                    <strong>Selecionar ou arrastar arquivo</strong>
                    <small>O arquivo sera convertido para base64 na integracao da logica.</small>
                    <em>Extensoes suportadas: .pdf, .png, .jpg, .jpeg</em>
                </label>

                <div class="anex-upload-card__hint">
                    <i class="icon-info"></i>
                    <span>{{
                            selectedAttachment ? 'Confira se o documento esta legivel antes de avancar.' : 'O upload fica disponível depois que um tipo de anexo for selecionado.'
                        }}</span>
                </div>
            </div>
        </div>

        <div class="anex-list-card">
            <div class="anex-list-card__header">
                <div>
                    <span class="anex-list-card__eyebrow">Arquivos selecionados</span>
                    <h5>Anexos adicionados</h5>
                </div>
                <span class="anex-list-card__badge">{{ anexes.length }} itens</span>
            </div>

            <div class="anex-list">
                <div v-for="(anex, k) in anexes" :key="k" class="anex-list__item">
                    <span class="anex-list__icon"><i class="icon-attachment"></i></span>
                    <div class="anex-list__content">
                        <strong>{{ anex.name }}</strong>
                        <small>{{ anex.typeName }} · {{ formatFileSize(anex.file_size) }}</small>
                    </div>
                    <span class="anex-list__status"
                          :class="{'anex-list__status--required': typesAnnex.required.find(i =>i.id === anex.drive_files_type_id)}">
                        {{
                            typesAnnex.required.find(i => i.id === anex.drive_files_type_id) ? 'Obrigatório' : 'Opcional'
                        }}
                    </span>
                    <button type="button" class="anex-list__remove" aria-label="Remover anexo" @click="removeAnnex(k)">
                        <i class="icon-trash-2"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import {mapMutations, mapState} from 'vuex';

export default {
    name: "createPublicPersonStepAnex",
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            selectedAttachmentType: null,
            selectedAttachmentTypeName: null,
            invalid:{},
        }
    },
    computed: {
        ...mapState({
            typesAnnex: (state) => state.publicClient.typesAnnex,
            anexes: (state) => state.publicClient.anexes,
        }),
        allAttachmentTypes() {
            return [
                ...(this.typesAnnex?.required || []),
                ...(this.typesAnnex?.not_required || []),
            ];
        },
        selectedAttachment() {
            return this.allAttachmentTypes.find(type => type.id === this.selectedAttachmentType) || null;
        },
        selectedAttachmentIsRequired() {
            return !!this.typesAnnex?.required?.some(type => type.id === this.selectedAttachmentType);
        },
        uploadedRequiredCount() {
            let count = this.typesAnnex.required?.length;
            this.typesAnnex.required?.forEach(typeAn => {
                if (!this.anexes.find(a => a.drive_files_type_id === typeAn.id)){
                    --count;
                }
            })
            return count;
        }
    },
    methods: {
        ...mapMutations({
            setAnexesPublicClientMutation:'setAnexesPublicClientMutation',
            pushAnexesPublicClientMutation:'pushAnexesPublicClientMutation',
        }),
        validateAnexos(){
            if (!this.typesAnnex?.required?.length){
                return true;
            }
            let can_continue = true;
            this.typesAnnex.required.forEach(i => {
                if (!this.anexes.find(a => a.drive_files_type_id === i.id)){
                    this.invalid[i.id] = 'Anexo Obrigatório';
                    can_continue = false;
                }else {
                    this.invalid[i.id] = null;
                }
            })
            return can_continue;
        },
        formatFileSize(bytes, decimals = 2) {
            if (!bytes || bytes === 0) {
                return '0 Bytes';
            }
            const base = 1024;
            const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
            const unitIndex = Math.floor(Math.log(bytes) / Math.log(base));
            const value = bytes / Math.pow(base, unitIndex);
            return `${value.toFixed(decimals)} ${units[unitIndex]}`;
        },
        removeAnnex(key) {
            this.setAnexesPublicClientMutation(this.anexes.filter((i, k) => k !== key));
        },
        async addFile(event) {
            const files = Array.from(event.target.files);
            await files.forEach(async (file) => {
                await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = (error) => {
                        reject(error);
                    };
                }).then(base64 => {
                    this.pushAnexesPublicClientMutation({
                        drive_files_type_id: this.selectedAttachmentType,
                        name: file.name,
                        file_size: file.size,
                        typeName: this.selectedAttachmentTypeName,
                        file: base64,
                        context_id: null,
                        context: 'clientes'
                    });
                    this.selectedAttachmentType = null;
                    this.selectedAttachmentTypeName = null;
                });
            })
        }
    }
}
</script>

<style scoped>
.public-client-anex-step {
    color: #243b35;
}

.anex-hero {
    align-items: stretch;
    background: linear-gradient(135deg, #0e5e4e 0%, #16886f 54%, #f2fbf8 54%, #ffffff 100%);
    border-radius: 22px;
    box-shadow: 0 18px 44px rgba(14, 94, 78, .16);
    display: flex;
    gap: 20px;
    justify-content: space-between;
    margin-bottom: 16px;
    overflow: hidden;
    padding: 28px;
}

.anex-hero__content {
    max-width: 650px;
    position: relative;
    z-index: 1;
}

.anex-hero__eyebrow,
.anex-types-card__eyebrow,
.anex-upload-card__eyebrow,
.anex-list-card__eyebrow {
    color: #55d5b6;
    display: inline-block;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: .12em;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.anex-hero__title {
    color: #ffffff;
    font-size: 28px;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 10px;
}

.anex-hero__text {
    color: rgba(255, 255, 255, .86);
    font-size: 15px;
    line-height: 1.6;
    margin: 0;
}

.anex-hero__status,
.anex-summary-card,
.anex-types-card,
.anex-upload-card,
.anex-list-card {
    background: #ffffff;
    border: 1px solid #e4eee9;
    border-radius: 20px;
    box-shadow: 0 16px 36px rgba(21, 56, 48, .08);
}

.anex-hero__status {
    align-items: flex-start;
    align-self: center;
    background: rgba(255, 255, 255, .92);
    border-color: rgba(255, 255, 255, .7);
    display: flex;
    flex-direction: column;
    min-width: 230px;
    padding: 18px;
}

.anex-hero__status-icon,
.anex-summary-card span,
.anex-type-option__icon,
.anex-dropzone__icon,
.anex-list__icon {
    align-items: center;
    background: #e8faf5;
    border-radius: 14px;
    color: #0e5e4e;
    display: flex;
    font-size: 22px;
    height: 46px;
    justify-content: center;
    width: 46px;
}

.anex-hero__status-icon {
    margin-bottom: 12px;
}

.anex-hero__status small,
.anex-summary-card small {
    color: #7a8c87;
    font-weight: 700;
    margin-bottom: 4px;
}

.anex-hero__status strong,
.anex-summary-card strong {
    color: #173b33;
    font-size: 16px;
}

.anex-summary-grid {
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-bottom: 16px;
}

.anex-summary-card {
    align-items: center;
    display: flex;
    gap: 14px;
    padding: 18px;
}

.anex-summary-card--required span {
    background: #fff4e5;
    color: #b76500;
}

.anex-upload-grid {
    display: grid;
    gap: 18px;
    grid-template-columns: minmax(0, 1fr) 380px;
    margin-bottom: 16px;
}

.anex-types-card,
.anex-upload-card,
.anex-list-card {
    padding: 24px;
}

.anex-types-card__header,
.anex-upload-card__header,
.anex-list-card__header {
    align-items: center;
    border-bottom: 1px solid #e6efeb;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 16px;
}

.anex-types-card__eyebrow,
.anex-upload-card__eyebrow,
.anex-list-card__eyebrow {
    color: #16886f;
    margin-bottom: 6px;
}

.anex-types-card h5,
.anex-upload-card h5,
.anex-list-card h5 {
    color: #173b33;
    font-weight: 800;
    margin-bottom: 4px;
}

.anex-types-card__badge,
.anex-upload-card__badge,
.anex-list-card__badge,
.anex-list__status {
    background: #e9fbf6;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 12px;
    font-weight: 800;
    padding: 8px 12px;
}

.anex-upload-card__badge--required,
.anex-list__status--required {
    background: #fff4e5;
    color: #b76500;
}

.anex-upload-card--disabled {
    background: linear-gradient(180deg, #fbfdfc 0%, #f6faf8 100%);
}

.anex-types-section + .anex-types-section {
    border-top: 1px dashed #dce9e4;
    margin-top: 16px;
    padding-top: 16px;
}

.anex-types-section__title {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.anex-types-section__title strong {
    color: #243b35;
    font-size: 14px;
    font-weight: 800;
}

.anex-types-section__title small {
    color: #71857f;
}

.anex-type-option {
    align-items: center;
    background: #f8fbfa;
    border: 1px solid #e0ece7;
    border-radius: 16px;
    cursor: pointer;
    display: grid;
    gap: 12px;
    grid-template-columns: 46px minmax(0, 1fr) auto;
    margin-bottom: 10px;
    padding: 14px;
    text-align: left;
    transition: all .2s ease;
    width: 100%;
}

.anex-type-option:hover,
.anex-type-option--active {
    background: #ecfbf7;
    border-color: #26b390;
    box-shadow: 0 10px 24px rgba(22, 136, 111, .14);
    transform: translateY(-1px);
}

.anex-type-option--done .anex-type-option__icon {
    background: #e9fbf6;
    color: #0e5e4e;
}

.anex-type-option__content strong {
    color: #1b3b34;
    display: block;
    font-size: 15px;
    margin-bottom: 3px;
}

.anex-type-option__content small {
    color: #71857f;
}

.anex-type-option__badge {
    background: #fff4e5;
    border-radius: 999px;
    color: #b76500;
    font-size: 11px;
    font-weight: 800;
    padding: 7px 10px;
}

.anex-type-option__badge--optional {
    background: #eef4f2;
    color: #647873;
}

.anex-dropzone {
    align-items: center;
    background: linear-gradient(180deg, #f8fdfb 0%, #ffffff 100%);
    border: 2px dashed #b8d9cf;
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 260px;
    padding: 28px;
    text-align: center;
    transition: all .2s ease;
}

.anex-dropzone:hover {
    border-color: #26b390;
    box-shadow: inset 0 0 0 1px rgba(38, 179, 144, .18);
}

.anex-upload-card__empty {
    align-items: center;
    background: #f8fbfa;
    border: 2px dashed #d2e4de;
    border-radius: 20px;
    color: #71857f;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 260px;
    padding: 28px;
    text-align: center;
}

.anex-upload-card__empty span {
    align-items: center;
    background: #eef4f2;
    border-radius: 16px;
    color: #7b908a;
    display: flex;
    font-size: 28px;
    height: 60px;
    justify-content: center;
    margin-bottom: 14px;
    width: 60px;
}

.anex-upload-card__empty strong {
    color: #3d554f;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 6px;
}

.anex-upload-card__empty small {
    line-height: 1.5;
    max-width: 260px;
}

.anex-dropzone__icon {
    font-size: 28px;
    height: 60px;
    margin-bottom: 14px;
    width: 60px;
}

.anex-dropzone strong {
    color: #173b33;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 6px;
}

.anex-dropzone small,
.anex-dropzone em {
    color: #71857f;
    font-style: normal;
    line-height: 1.5;
}

.anex-dropzone em {
    font-size: 12px;
    margin-top: 10px;
}

.anex-upload-card__hint {
    align-items: center;
    background: #f8fbfa;
    border-radius: 14px;
    color: #60766f;
    display: flex;
    gap: 10px;
    margin-top: 14px;
    padding: 12px 14px;
}

.anex-list {
    display: grid;
    gap: 10px;
}

.anex-list__item {
    align-items: center;
    background: #f8fbfa;
    border: 1px solid #e0ece7;
    border-radius: 16px;
    display: grid;
    gap: 12px;
    grid-template-columns: 46px minmax(0, 1fr) auto 38px;
    padding: 14px;
}

.anex-list__content strong {
    color: #173b33;
    display: block;
    font-weight: 800;
    margin-bottom: 3px;
}

.anex-list__content small {
    color: #71857f;
}

.anex-list__remove {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e4eee9;
    border-radius: 12px;
    color: #b53f3f;
    cursor: pointer;
    display: flex;
    height: 38px;
    justify-content: center;
    width: 38px;
}

html.dark-theme .public-client-anex-step {
    color: var(--dark-text-soft);
}

html.dark-theme .anex-hero {
    background: linear-gradient(135deg, #064e3b 0%, #0f766e 52%, var(--dark-surface-2) 52%, var(--dark-surface) 100%);
    box-shadow: var(--dark-shadow);
}

html.dark-theme .anex-hero__status,
html.dark-theme .anex-summary-card,
html.dark-theme .anex-types-card,
html.dark-theme .anex-upload-card,
html.dark-theme .anex-list-card,
html.dark-theme .anex-list__item {
    background: var(--dark-surface) !important;
    border-color: var(--dark-border) !important;
    box-shadow: var(--dark-shadow) !important;
}

html.dark-theme .anex-hero__status {
    background: rgba(17, 24, 39, .92) !important;
}

html.dark-theme .anex-type-option,
html.dark-theme .anex-dropzone,
html.dark-theme .anex-upload-card__empty,
html.dark-theme .anex-upload-card__hint {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
}

html.dark-theme .anex-hero__status-icon,
html.dark-theme .anex-summary-card span,
html.dark-theme .anex-type-option__icon,
html.dark-theme .anex-dropzone__icon,
html.dark-theme .anex-upload-card__empty span,
html.dark-theme .anex-list__icon {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}

html.dark-theme .anex-summary-card--required span,
html.dark-theme .anex-type-option__badge,
html.dark-theme .anex-upload-card__badge--required,
html.dark-theme .anex-list__status--required {
    background: rgba(251, 191, 36, .14) !important;
    color: var(--dark-warning) !important;
}

html.dark-theme .anex-type-option:hover,
html.dark-theme .anex-type-option--active {
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-primary) !important;
}

html.dark-theme .anex-hero__status strong,
html.dark-theme .anex-summary-card strong,
html.dark-theme .anex-types-card h5,
html.dark-theme .anex-upload-card h5,
html.dark-theme .anex-list-card h5,
html.dark-theme .anex-types-section__title strong,
html.dark-theme .anex-type-option__content strong,
html.dark-theme .anex-dropzone strong,
html.dark-theme .anex-upload-card__empty strong,
html.dark-theme .anex-list__content strong {
    color: var(--dark-text) !important;
}

html.dark-theme .anex-hero__status small,
html.dark-theme .anex-summary-card small,
html.dark-theme .anex-types-section__title small,
html.dark-theme .anex-type-option__content small,
html.dark-theme .anex-dropzone small,
html.dark-theme .anex-dropzone em,
html.dark-theme .anex-upload-card__empty small,
html.dark-theme .anex-upload-card__hint,
html.dark-theme .anex-list__content small {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .anex-types-card__badge,
html.dark-theme .anex-upload-card__badge,
html.dark-theme .anex-list-card__badge,
html.dark-theme .anex-list__status,
html.dark-theme .anex-type-option__badge--optional {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}

html.dark-theme .anex-types-section + .anex-types-section {
    border-top-color: var(--dark-border) !important;
}

html.dark-theme .anex-list__remove {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-danger) !important;
}

@media (max-width: 991.98px) {
    .anex-hero {
        background: linear-gradient(160deg, #0e5e4e 0%, #16886f 100%);
        flex-direction: column;
    }

    .anex-hero__status {
        align-self: stretch;
    }

    .anex-summary-grid,
    .anex-upload-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 575.98px) {
    .public-client-anex-step {
        margin-left: -6px;
        margin-right: -6px;
    }

    .anex-hero,
    .anex-summary-card,
    .anex-types-card,
    .anex-upload-card,
    .anex-list-card {
        border-radius: 16px;
        padding: 16px 12px;
    }

    .anex-hero {
        gap: 14px;
        margin-bottom: 12px;
    }

    .anex-hero__eyebrow,
    .anex-types-card__eyebrow,
    .anex-upload-card__eyebrow,
    .anex-list-card__eyebrow {
        font-size: 10px;
        margin-bottom: 8px;
    }

    .anex-hero__title {
        font-size: 21px;
        line-height: 1.22;
        margin-bottom: 8px;
    }

    .anex-hero__text {
        font-size: 13px;
        line-height: 1.45;
    }

    .anex-hero__status {
        align-items: center;
        border-radius: 14px;
        display: grid;
        gap: 4px 10px;
        grid-template-columns: 40px minmax(0, 1fr);
        min-width: 0;
        padding: 12px;
    }

    .anex-hero__status-icon {
        grid-row: span 2;
        height: 40px;
        margin-bottom: 0;
        width: 40px;
    }

    .anex-hero__status small,
    .anex-hero__status strong {
        margin-bottom: 0;
    }

    .anex-summary-grid,
    .anex-upload-grid {
        gap: 12px;
        margin-bottom: 12px;
    }

    .anex-summary-grid {
        grid-template-columns: 1fr;
    }

    .anex-summary-card {
        gap: 12px;
    }

    .anex-summary-card span,
    .anex-type-option__icon,
    .anex-list__icon {
        height: 40px;
        width: 40px;
    }

    .anex-types-card__header,
    .anex-upload-card__header,
    .anex-list-card__header,
    .anex-types-section__title {
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 14px;
        padding-bottom: 14px;
    }

    .anex-types-card h5,
    .anex-upload-card h5,
    .anex-list-card h5 {
        font-size: 17px;
    }

    .anex-types-card__badge,
    .anex-upload-card__badge,
    .anex-list-card__badge,
    .anex-list__status {
        font-size: 11px;
        padding: 7px 10px;
    }

    .anex-types-section + .anex-types-section {
        margin-top: 14px;
        padding-top: 14px;
    }

    .anex-types-section__title strong {
        font-size: 13px;
    }

    .anex-types-section__title small,
    .anex-type-option__content small,
    .anex-dropzone small,
    .anex-dropzone em,
    .anex-upload-card__hint,
    .anex-upload-card__empty small,
    .anex-list__content small {
        font-size: 12px;
        line-height: 1.4;
    }

    .anex-type-option,
    .anex-list__item {
        border-radius: 14px;
        gap: 10px;
        grid-template-columns: 40px minmax(0, 1fr);
        padding: 10px;
    }

    .anex-type-option__content strong,
    .anex-list__content strong {
        font-size: 13px;
        overflow-wrap: anywhere;
    }

    .anex-dropzone,
    .anex-upload-card__empty {
        border-radius: 16px;
        min-height: 210px;
        padding: 20px 14px;
    }

    .anex-dropzone__icon,
    .anex-upload-card__empty span {
        height: 52px;
        margin-bottom: 12px;
        width: 52px;
    }

    .anex-dropzone strong,
    .anex-upload-card__empty strong {
        font-size: 15px;
    }

    .anex-upload-card__hint {
        align-items: flex-start;
        border-radius: 12px;
        margin-top: 12px;
        padding: 10px 12px;
    }

    .anex-type-option__badge,
    .anex-list__status,
    .anex-list__remove {
        grid-column: 2;
        justify-self: start;
    }
}

@media (max-width: 991.98px) {
    html.dark-theme .anex-hero {
        background: linear-gradient(160deg, #064e3b 0%, var(--dark-surface-2) 100%) !important;
    }
}

</style>
